import {
  About,
  Cassava,
  Commerce,
  Developers,
  Home,
  FAQS,
  Token,
  Wallet,
} from "../pages";

const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "about",
    component: About,
  },
  {
    path: "products/mula-wallet",
    component: Wallet,
  },
  {
    path: "products/commerce",
    component: Commerce,
  },
  {
    path: "products/cassava",
    component: Cassava,
  },
  {
    path: "products/developers",
    component: Developers,
  },
  {
    path: "mula-token",
    component: Token,
  },
  {
    path: "faqs",
    component: FAQS,
  },
];

export default routes;
